// extracted by mini-css-extract-plugin
export default {"wrap":"Cookies_wrap__ae0Op","btnWrap":"Cookies_btnWrap__DYxSp","btn":"Cookies_btn__dPqEG"};